export default __webpack_public_path__ + "static/media/winner-icon1.4e9845ff.svg";